import Header from './Header'
import DynamicButton from './Header.DynamicButton'

import './style.scss'

export { Header, DynamicButton }
export default Header
